import { useSceneEntities } from "@/stores/SceneEntities";
import { usePresetsBuild } from "@/scripts/rooms/actions/general/PresetsBuild";
export function usePresetSetDefault(payload, viewport) {
  
  const sceneEntities = useSceneEntities();
  sceneEntities.setPresetDefault(payload);
  sceneEntities.savePresetsPersistant();
  usePresetsBuild();
}
